import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import MenuPage from "./pages/MenuPage";
import LandingPage from "./pages/LandingPage";
import OrderConfirmationPage from "./pages/OrderConfirmationPage";
import RatingPage from "./pages/RatingPage";
import RateVisitPage from "./pages/RateVisitPage";
import "./App.css";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/order" element={<MenuPage />} />
        <Route path="/order/confirm/:orderId" element={<OrderConfirmationPage />} />
        <Route path="/rate/:orderId" element={<RatingPage />} />
        <Route path="/rate-visit" element={<RateVisitPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
